import Vue from 'vue'
import axios from 'axios'

import {
  SONGWRITER_ALL,
  SONGWRITER_ALL_FOR_FORM,
  SONGWRITER_CREATE,
  SONGWRITER_READ,
  SONGWRITER_UPDATE,
  SONGWRITER_DELETE
} from '../actions'

import {
  CLEAR_STORE,
  SONGWRITER_LOADING,
  SONGWRITER_SUCCESS,
  SONGWRITER_ERROR,
  SONGWRITER_SET,
  SONGWRITERS_SET,
  SONGWRITER_CURRENT_PAGE_SET,
  SONGWRITER_PER_PAGE_SET,
  SONGWRITER_TOTAL_PAGES_SET,
  SONGWRITER_SEARCH_VALUE_SET
} from '../mutations'

export default {
  state: {
    status: '',
    songwriters: [],
    songwriter: {},
    perPage: 15,
    currentPage: 1,
    totalPages: 0,
    searchValue: ''
  },

  mutations: {
    [SONGWRITER_LOADING]: (state) => {
      state.status = 'loading'
    },
    [SONGWRITER_SUCCESS]: (state) => {
      state.status = 'success'
    },
    [SONGWRITER_ERROR]: (state) => {
      state.status = 'error'
    },
    [SONGWRITER_SET]: (state, resp) => {
      Vue.set(state, 'songwriter', resp)
    },
    [SONGWRITERS_SET]: (state, resp) => {
      Vue.set(state, 'songwriters', resp)
    },
    [SONGWRITER_PER_PAGE_SET]: (state, value) => {
      state.perPage = value
    },
    [SONGWRITER_CURRENT_PAGE_SET]: (state, value) => {
      state.currentPage = value
    },
    [SONGWRITER_TOTAL_PAGES_SET]: (state, value) => {
      state.totalPages = value
    },
    [SONGWRITER_SEARCH_VALUE_SET]: (state, value) => {
      state.searchValue = value
    },
    [CLEAR_STORE]: (state) => {
      Vue.set(state, 'songwriter', {})
      Vue.set(state, 'songwriters', [])
    }
  },

  actions: {
    [SONGWRITER_ALL]: ({
      commit,
      state,
      getters
    }) => {
      commit(SONGWRITER_LOADING)

      let accountId = getters.getActiveAccountId

      if (!accountId) {
        commit(SONGWRITER_ERROR)
        return false
      }

      let params = {
        page: state.currentPage,
        per_page: state.perPage
      }

      if (state.searchValue && state.searchValue.length) {
        params.search = state.searchValue
      }

      axios({
        url: 'accounts/' + accountId + '/search/songwriters',
        params: params
      })
        .then(resp => {
          commit(SONGWRITER_SUCCESS)
          commit(SONGWRITERS_SET, resp.data.data)
          commit(SONGWRITER_TOTAL_PAGES_SET, resp.data.meta.last_page)
        })
        .catch(resp => {
          commit(SONGWRITER_ERROR)
        })
    },

    [SONGWRITER_ALL_FOR_FORM]: ({
      commit,
      getters
    }) => {
      commit(SONGWRITER_LOADING)
      return new Promise((resolve, reject) => {
        let accountId = getters.getActiveAccountId

        if (!accountId) {
          commit(SONGWRITER_ERROR)
          return false
        }

        axios({
          url: 'accounts/' + accountId + '/songwriters'
        })
          .then(resp => {
            commit(SONGWRITER_SUCCESS)
            commit(SONGWRITERS_SET, resp.data.data)
            resolve(resp.data.data)
          })
          .catch(err => {
            commit(SONGWRITER_ERROR)
            reject(err)
          })
      })
    },

    [SONGWRITER_READ]: ({
      commit
    }, id) => {
      commit(SONGWRITER_LOADING)
      commit(SONGWRITER_SET, {})
      axios({
        url: 'songwriters/' + id
      })
        .then(resp => {
          commit(SONGWRITER_SUCCESS)
          commit(SONGWRITER_SET, resp.data.data)
        })
        .catch(resp => {
          commit(SONGWRITER_ERROR)
        })
    },

    [SONGWRITER_CREATE]: ({
      commit,
      dispatch,
      getters
    }, data) => {
      return new Promise((resolve, reject) => {
        commit(SONGWRITER_LOADING)
        commit(SONGWRITER_SET, {})

        let accountId = getters.getActiveAccountId

        if (!accountId) {
          commit(SONGWRITER_ERROR)
          reject(new Error('No account found'))
          return false
        }

        axios({
          method: 'post',
          url: 'accounts/' + accountId + '/songwriters',
          data: data
        })
          .then(resp => {
            commit(SONGWRITER_SUCCESS)
            commit(SONGWRITER_SET, resp.data.data)
            commit(SONGWRITER_SEARCH_VALUE_SET, null)
            dispatch(SONGWRITER_ALL_FOR_FORM)
            resolve(resp.data.data)
          })
          .catch(err => {
            commit(SONGWRITER_ERROR)
            reject(err)
          })
      })
    },

    [SONGWRITER_UPDATE]: ({
      commit,
      dispatch
    }, {
      id,
      data
    }) => {
      return new Promise((resolve, reject) => {
        commit(SONGWRITER_LOADING)
        axios({
          method: 'put',
          url: 'songwriters/' + id,
          data: data
        })
          .then(resp => {
            commit(SONGWRITER_SUCCESS)
            commit(SONGWRITER_SET, resp.data.data)
            dispatch(SONGWRITER_ALL)
            resolve(resp.data.data)
          })
          .catch(err => {
            commit(SONGWRITER_ERROR)
            reject(err)
          })
      })
    },

    [SONGWRITER_DELETE]: ({
      commit,
      dispatch
    }, id) => {
      return new Promise((resolve, reject) => {
        commit(SONGWRITER_LOADING)

        axios({
          method: 'delete',
          url: 'songwriters/' + id
        })
          .then(resp => {
            commit(SONGWRITER_SET, {})
            dispatch(SONGWRITER_ALL)
            resolve(resp)
          })
          .catch(err => {
            commit(SONGWRITER_ERROR)
            reject(err)
          })
      })
    }
  }
}
